// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__4wrBT","description":"PatientConsentPreview_description__3yW6z"};